import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { Calendar } from "primereact/calendar";
import { ProgressSpinner } from "primereact/progressspinner";

const ExpenseEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      Http.get(`/accounts/expenses/${id}`),
      Http.get("/accounts/expense-categories")
    ])
      .then(([expenseRes, categoriesRes]) => {
        const expenseData = expenseRes.data.data;
        if (expenseData.date) {
          expenseData.date = new Date(expenseData.date);
        }
        setInputs(expenseData);
        setCategories(categoriesRes.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleDateChange = (e) => {
    setInputs((values) => ({ ...values, date: e.value }));
  };

  const formSubmit = () => {
    Http.put(`/accounts/expenses/${id}`, inputs)
      .then((res) => {
        navigate("/expenses", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Expense</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Expense Information</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>Date <span className="text-danger">*</span></label>
                    <Calendar
                      value={inputs.date}
                      onChange={handleDateChange}
                      dateFormat="dd/mm/yy"
                      className="w-100"
                    />
                  </div>
                  <div className="col-lg">
                    <label>Category <span className="text-danger">*</span></label>
                    <select
                      className="form-control"
                      name="expense_category_id"
                      value={inputs.expense_category_id || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Category</option>
                      {categories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Amount <span className="text-danger">*</span></label>
                    <input
                      type="number"
                      className="form-control"
                      name="amount"
                      value={inputs.amount || ""}
                      onChange={handleChange}
                      placeholder="Enter Amount"
                    />
                  </div>
                  <div className="col-lg">
                    <label>Reference</label>
                    <input
                      type="text"
                      className="form-control"
                      name="reference"
                      value={inputs.reference || ""}
                      onChange={handleChange}
                      placeholder="Enter Reference"
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={inputs.description || ""}
                      onChange={handleChange}
                      placeholder="Enter Description"
                      rows="3"
                    ></textarea>
                  </div>
                  {/* <div className="col-lg">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="status"
                      value={inputs.status || ""}
                      onChange={handleChange}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div> */}
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseEdit;